import { render, staticRenderFns } from "./DrawPrizeModule.vue?vue&type=template&id=dbeee05e&scoped=true&"
import script from "./DrawPrizeModule.vue?vue&type=script&lang=js&"
export * from "./DrawPrizeModule.vue?vue&type=script&lang=js&"
import style0 from "./DrawPrizeModule.vue?vue&type=style&index=0&id=dbeee05e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbeee05e",
  null
  
)

export default component.exports